module.exports = __webpack_public_path__ + "static/img/45.c0e7582e.png";